import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import Solution from '../components/solution/solution.vue'
import Wisdommarket from '../components/solution/Wisdommarket.vue'
import Smarttrade from '../components/solution/Smarttrade.vue'
import Payplatform from '../components/solution/payplatform.vue'
import Loadometer from "../components/solution/loadometer.vue"

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/solution',
        name: 'Solution',
        redirect: '/solution/Wisdommarket',
        component: Solution,
        children: [
            {
                path: 'Wisdommarket',
                name: 'Wisdommarket',
                component: Wisdommarket
            },
            {
                path: 'Smarttrade',
                name: 'Smarttrade',
                component: Smarttrade
            }, {
                path: 'Loadometer',
                name: 'Loadometer',
                component: Loadometer
            }
            , {
                path: 'Payplatform',
                name: 'Payplatform',
                component: Payplatform
            }
        ]

    },
    //  智慧农批
    {
        path: '/SmartAgriculture',
        name: 'SmartAgriculture',
        component: () => import('@/views/smartAgriculture.vue')
    },
    //  智慧农贸
    {
        path: '/SmartTrade',
        name: 'SmartTrade',
        component: () => import('@/views/smartTrade.vue')
    },
    //  智慧园区
    {
        path: '/SmartPark',
        name: 'SmartPark',
        component: () => import('@/views/smartPark.vue')
    },
    //  系统平台
    {
        path: '/systemPlatform',
        name: 'systemPlatform',
        component: () => import('@/views/systemPlatform.vue')
    },
    //  硬件产品
    {
        path: '/hardwareProducts',
        name: 'hardwareProducts',
        component: () => import('@/views/hardwareProducts.vue')
    },
    // 兼容旧地址
    {
        path: '/ProjectCase',
        redirect: '/industryNews'
    },
    // 行业资讯
    {
        path: '/industryNews',
        name: 'IndustryNews',
        component: () => import('@/views/projectCase.vue')
    },
    // 产品定价新
    {
        path: '/projectPrices',
        name: 'projectPrices',
        component: () => import('@/views/projectPrices.vue')
    },
    {
        path: '/AboutUs',
        name: 'AboutUs',
        component: () => import('@/views/aboutUs.vue')
    },
    {
        path: '/test',
        name: 'test',
        component: () => import('@/views/test.vue')
    },


]

const router = new VueRouter({
    // mode: "history",
    routes,
    scrollBehavior(to, from, savedPosition) {
        if(savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})

export default router
